module.exports = __webpack_public_path__ + "static/img/irole.0378fb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/zxrx/irole.png
// module id = z7FD
// module chunks = 7